exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".generic-selector[data-v-d9e4fd8a] {\n  height: 40px;\n  padding-left: 8px;\n  padding-right: 8px;\n  min-width: 50px;\n}\n.generic-selector[data-v-d9e4fd8a]:hover, .generic-selector[data-v-d9e4fd8a]:focus {\n    border-width: 2px;\n}\n.generic-selector.active[data-v-d9e4fd8a] {\n    border-color: #828282;\n    border-width: 2px;\n    color: #828282;\n}\n.generic-selector[data-v-d9e4fd8a]:disabled {\n    border-color: #e0e0e0;\n    color: #e0e0e0;\n    cursor: not-allowed;\n}\n.generic-selector[data-v-d9e4fd8a]:disabled:hover, .generic-selector[data-v-d9e4fd8a]:disabled:after {\n      border-width: 1px;\n}\n", ""]);

// exports
